import { render, staticRenderFns } from "./companyDetail.vue?vue&type=template&id=60afa9db&scoped=true"
import script from "./companyDetail.vue?vue&type=script&lang=js"
export * from "./companyDetail.vue?vue&type=script&lang=js"
import style0 from "./companyDetail.vue?vue&type=style&index=0&id=60afa9db&prod&lang=scss&scoped=true"
import style1 from "./companyDetail.vue?vue&type=style&index=1&id=60afa9db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60afa9db",
  null
  
)

export default component.exports